import { getMediaDevices } from '@gem/call/Removable/packages/deviceInfo/deviceInfo';
import { media } from '@gem/call/Removable/packages/permissions/permissions';
import { t } from '@gem/modules/i18n';
import { popupsTasks } from '@gem/popups';

export const hasMicrophonePermission = async (): Promise<boolean> => {
  const { hasMicrophone } = await getMediaDevices();

  if (!hasMicrophone) {
    popupsTasks.showAlert(t('calls_no_microphone_connected'));

    return false;
  }

  const hasAudioPermission = await media.getAudioPermission();

  if (!hasAudioPermission) {
    popupsTasks.showAlert(t('calls_no_microphone_permissions'));

    return false;
  }

  return true;
};
